const CallToActionWithAlignmentTypes = {
  LEFT: 'left',
  RIGHT: 'right',
};

module.exports = CallToActionWithAlignmentTypes;
